import { React } from '_core';

import { AsyncDataGridContextProvider, ProviderProps } from './async-context';
import DataGrid from './data-grid';

const AsyncDataGrid = (props: ProviderProps) => {
  return (
    <AsyncDataGridContextProvider {...props}>
      <DataGrid />
    </AsyncDataGridContextProvider>
  );
};

export default AsyncDataGrid;
